/* Контент лежит НАД атмосферой. Она фиксирована на --z-base, поэтому
   каждому корневому контейнеру нужен свой слой — иначе туман окажется
   поверх текста. */
.app {
  position: relative;
  z-index: 1;
  max-width: 34rem;
  margin-inline: auto;
  /* Нижний отступ считается от безопасной зоны Telegram, а не от края
     экрана: под ним живут системный жест и «домашняя полоса». Берём
     максимум из трёх, потому что env() внутри мини-аппа исторически
     врёт, а переменная Telegram появилась не во всех клиентах. */
  padding:
    var(--sp-6) var(--sp-gutter)
    calc(var(--sp-16) + max(env(safe-area-inset-bottom, 0px), var(--tg-safe-area-inset-bottom, 0px)));
}

.header { margin-bottom: var(--sp-5); }

.title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-4);
  margin-top: var(--sp-1);
}

/* Золото и засечки: валюта — сакральное, а не интерактивное.
   Её не нажимают, поэтому она не красится акцентом. */
.balance {
  flex: none;
  font: var(--t-numeric-m);
  font-variant-numeric: tabular-nums;
  color: var(--c-sacred);
  padding: var(--sp-1) var(--sp-3);
  border: 1px solid var(--c-border-sacred);
  border-radius: var(--r-pill);
}

.tabs {
  display: flex;
  gap: var(--sp-2);
  margin-bottom: var(--sp-6);
}

.tab {
  min-height: 36px;
  padding-inline: var(--sp-4);
  border-radius: var(--r-pill);
  border: 1px solid var(--c-border-subtle);
  background: var(--c-surface);
  color: var(--c-text-tertiary);
  font: var(--t-label-m);
  transition:
    color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}

.tab[aria-current='page'] {
  color: var(--c-text-primary);
  border-color: var(--c-accent);
}

.content { min-height: 60dvh; }

.center {
  position: relative;
  z-index: 1;
  /* Не 100dvh: пока человек тянет шторку мини-аппа, высота вьюпорта
     меняется каждый кадр, и вёрстка на dvh прыгает весь жест.
     Telegram отдаёт отдельную «стабильную» высоту ровно для этого. */
  min-height: var(--tg-viewport-stable-height, 100dvh);
  display: grid;
  place-items: center;
  padding: var(--sp-6);
}

.cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: var(--tap-min);
  padding-inline: var(--sp-6);
  border-radius: var(--r-md);
  background: var(--c-grad-cta);
  color: var(--c-text-on-accent);
  font: var(--t-label-l);
  box-shadow: var(--sh-1);
}
